import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import GoTrueAdminApi from './GoTrueAdminApi';
import { DEFAULT_HEADERS, EXPIRY_MARGIN, GOTRUE_URL, STORAGE_KEY } from './lib/constants';
import { AuthImplicitGrantRedirectError, AuthPKCEGrantCodeExchangeError, AuthInvalidCredentialsError, AuthRetryableFetchError, AuthSessionMissingError, AuthUnknownError, isAuthApiError, isAuthError } from './lib/errors';
import { _request, _sessionResponse, _userResponse, _ssoResponse } from './lib/fetch';
import { decodeJWTPayload, Deferred, getItemAsync, getParameterByName, isBrowser, removeItemAsync, resolveFetch, setItemAsync, uuid, retryable, sleep, generatePKCEVerifier, generatePKCEChallenge } from './lib/helpers';
import localStorageAdapter from './lib/local-storage';
import { polyfillGlobalThis } from './lib/polyfills';
polyfillGlobalThis(); // Make "globalThis" available
var DEFAULT_OPTIONS = {
  url: GOTRUE_URL,
  storageKey: STORAGE_KEY,
  autoRefreshToken: true,
  persistSession: true,
  detectSessionInUrl: true,
  headers: DEFAULT_HEADERS,
  flowType: 'implicit'
};
/** Current session will be checked for refresh at this interval. */
var AUTO_REFRESH_TICK_DURATION = 10 * 1000;
/**
 * A token refresh will be attempted this many ticks before the current session expires. */
var AUTO_REFRESH_TICK_THRESHOLD = 3;
var GoTrueClient = /*#__PURE__*/function () {
  /**
   * Create a new client for use in the browser.
   */
  function GoTrueClient(options) {
    var _this = this;
    _classCallCheck(this, GoTrueClient);
    var _a;
    this.stateChangeEmitters = new Map();
    this.autoRefreshTicker = null;
    this.visibilityChangedCallback = null;
    this.refreshingDeferred = null;
    /**
     * Keeps track of the async client initialization.
     * When null or not yet resolved the auth state is `unknown`
     * Once resolved the the auth state is known and it's save to call any further client methods.
     * Keep extra care to never reject or throw uncaught errors
     */
    this.initializePromise = null;
    this.detectSessionInUrl = true;
    /**
     * Used to broadcast state change events to other tabs listening.
     */
    this.broadcastChannel = null;
    var settings = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    this.inMemorySession = null;
    this.storageKey = settings.storageKey;
    this.autoRefreshToken = settings.autoRefreshToken;
    this.persistSession = settings.persistSession;
    this.storage = settings.storage || localStorageAdapter;
    this.admin = new GoTrueAdminApi({
      url: settings.url,
      headers: settings.headers,
      fetch: settings.fetch
    });
    this.url = settings.url;
    this.headers = settings.headers;
    this.fetch = resolveFetch(settings.fetch);
    this.detectSessionInUrl = settings.detectSessionInUrl;
    this.flowType = settings.flowType;
    this.mfa = {
      verify: this._verify.bind(this),
      enroll: this._enroll.bind(this),
      unenroll: this._unenroll.bind(this),
      challenge: this._challenge.bind(this),
      listFactors: this._listFactors.bind(this),
      challengeAndVerify: this._challengeAndVerify.bind(this),
      getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
    };
    if (isBrowser() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
      try {
        this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
      } catch (e) {
        console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
      }
      (_a = this.broadcastChannel) === null || _a === void 0 ? void 0 : _a.addEventListener('message', function (event) {
        _this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
      });
    }

    this.initialize();
  }
  /**
   * Initializes the client session either from the url or from storage.
   * This method is automatically called when instantiating the client, but should also be called
   * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
   */
  _createClass(GoTrueClient, [{
    key: "initialize",
    value: function initialize() {
      if (!this.initializePromise) {
        this.initializePromise = this._initialize();
      }
      return this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */
  }, {
    key: "_initialize",
    value: function _initialize() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var isPKCEFlow, _yield$this$_getSessi, data, error, session, redirectType;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.initializePromise) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", this.initializePromise);
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return this._isPKCEFlow();
            case 5:
              isPKCEFlow = _context.sent;
              if (!(this.detectSessionInUrl && this._isImplicitGrantFlow() || isPKCEFlow)) {
                _context.next = 21;
                break;
              }
              _context.next = 9;
              return this._getSessionFromUrl(isPKCEFlow);
            case 9:
              _yield$this$_getSessi = _context.sent;
              data = _yield$this$_getSessi.data;
              error = _yield$this$_getSessi.error;
              if (!error) {
                _context.next = 16;
                break;
              }
              _context.next = 15;
              return this._removeSession();
            case 15:
              return _context.abrupt("return", {
                error: error
              });
            case 16:
              session = data.session, redirectType = data.redirectType;
              _context.next = 19;
              return this._saveSession(session);
            case 19:
              setTimeout(function () {
                if (redirectType === 'recovery') {
                  _this2._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                } else {
                  _this2._notifyAllSubscribers('SIGNED_IN', session);
                }
              }, 0);
              return _context.abrupt("return", {
                error: null
              });
            case 21:
              _context.next = 23;
              return this._recoverAndRefresh();
            case 23:
              return _context.abrupt("return", {
                error: null
              });
            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](2);
              if (!isAuthError(_context.t0)) {
                _context.next = 30;
                break;
              }
              return _context.abrupt("return", {
                error: _context.t0
              });
            case 30:
              return _context.abrupt("return", {
                error: new AuthUnknownError('Unexpected error during initialization', _context.t0)
              });
            case 31:
              _context.prev = 31;
              _context.next = 34;
              return this._handleVisibilityChange();
            case 34:
              return _context.finish(31);
            case 35:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 26, 31, 35]]);
      }));
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */
  }, {
    key: "signUp",
    value: function signUp(credentials) {
      var _a, _b, _c;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, email, password, options, phone, _password, _options, _res, data, error, session, user;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this._removeSession();
            case 3:
              if (!('email' in credentials)) {
                _context2.next = 10;
                break;
              }
              email = credentials.email, password = credentials.password, options = credentials.options;
              _context2.next = 7;
              return _request(this.fetch, 'POST', "".concat(this.url, "/signup"), {
                headers: this.headers,
                redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                body: {
                  email: email,
                  password: password,
                  data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                  gotrue_meta_security: {
                    captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                  }
                },
                xform: _sessionResponse
              });
            case 7:
              res = _context2.sent;
              _context2.next = 18;
              break;
            case 10:
              if (!('phone' in credentials)) {
                _context2.next = 17;
                break;
              }
              phone = credentials.phone, _password = credentials.password, _options = credentials.options;
              _context2.next = 14;
              return _request(this.fetch, 'POST', "".concat(this.url, "/signup"), {
                headers: this.headers,
                body: {
                  phone: phone,
                  password: _password,
                  data: (_b = _options === null || _options === void 0 ? void 0 : _options.data) !== null && _b !== void 0 ? _b : {},
                  channel: (_c = _options === null || _options === void 0 ? void 0 : _options.channel) !== null && _c !== void 0 ? _c : 'sms',
                  gotrue_meta_security: {
                    captcha_token: _options === null || _options === void 0 ? void 0 : _options.captchaToken
                  }
                },
                xform: _sessionResponse
              });
            case 14:
              res = _context2.sent;
              _context2.next = 18;
              break;
            case 17:
              throw new AuthInvalidCredentialsError('You must provide either an email or phone number and a password');
            case 18:
              _res = res, data = _res.data, error = _res.error;
              if (!(error || !data)) {
                _context2.next = 21;
                break;
              }
              return _context2.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: error
              });
            case 21:
              session = data.session;
              user = data.user;
              if (!data.session) {
                _context2.next = 27;
                break;
              }
              _context2.next = 26;
              return this._saveSession(data.session);
            case 26:
              this._notifyAllSubscribers('SIGNED_IN', session);
            case 27:
              return _context2.abrupt("return", {
                data: {
                  user: user,
                  session: session
                },
                error: null
              });
            case 30:
              _context2.prev = 30;
              _context2.t0 = _context2["catch"](0);
              if (!isAuthError(_context2.t0)) {
                _context2.next = 34;
                break;
              }
              return _context2.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: _context2.t0
              });
            case 34:
              throw _context2.t0;
            case 35:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 30]]);
      }));
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */
  }, {
    key: "signInWithPassword",
    value: function signInWithPassword(credentials) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, email, password, options, phone, _password2, _options2, _res2, data, error;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this._removeSession();
            case 3:
              if (!('email' in credentials)) {
                _context3.next = 10;
                break;
              }
              email = credentials.email, password = credentials.password, options = credentials.options;
              _context3.next = 7;
              return _request(this.fetch, 'POST', "".concat(this.url, "/token?grant_type=password"), {
                headers: this.headers,
                body: {
                  email: email,
                  password: password,
                  gotrue_meta_security: {
                    captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                  }
                },
                xform: _sessionResponse
              });
            case 7:
              res = _context3.sent;
              _context3.next = 18;
              break;
            case 10:
              if (!('phone' in credentials)) {
                _context3.next = 17;
                break;
              }
              phone = credentials.phone, _password2 = credentials.password, _options2 = credentials.options;
              _context3.next = 14;
              return _request(this.fetch, 'POST', "".concat(this.url, "/token?grant_type=password"), {
                headers: this.headers,
                body: {
                  phone: phone,
                  password: _password2,
                  gotrue_meta_security: {
                    captcha_token: _options2 === null || _options2 === void 0 ? void 0 : _options2.captchaToken
                  }
                },
                xform: _sessionResponse
              });
            case 14:
              res = _context3.sent;
              _context3.next = 18;
              break;
            case 17:
              throw new AuthInvalidCredentialsError('You must provide either an email or phone number and a password');
            case 18:
              _res2 = res, data = _res2.data, error = _res2.error;
              if (!(error || !data)) {
                _context3.next = 21;
                break;
              }
              return _context3.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: error
              });
            case 21:
              if (!data.session) {
                _context3.next = 25;
                break;
              }
              _context3.next = 24;
              return this._saveSession(data.session);
            case 24:
              this._notifyAllSubscribers('SIGNED_IN', data.session);
            case 25:
              return _context3.abrupt("return", {
                data: data,
                error: error
              });
            case 28:
              _context3.prev = 28;
              _context3.t0 = _context3["catch"](0);
              if (!isAuthError(_context3.t0)) {
                _context3.next = 32;
                break;
              }
              return _context3.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: _context3.t0
              });
            case 32:
              throw _context3.t0;
            case 33:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 28]]);
      }));
    }
    /**
     * Log in an existing user via a third-party provider.
     */
  }, {
    key: "signInWithOAuth",
    value: function signInWithOAuth(credentials) {
      var _a, _b, _c, _d, _e;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this._removeSession();
            case 2:
              _context4.next = 4;
              return this._handleProviderSignIn(credentials.provider, {
                redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect,
                flowType: (_e = this.flowType) !== null && _e !== void 0 ? _e : 'implicit'
              });
            case 4:
              return _context4.abrupt("return", _context4.sent);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
    /**
     * Log in an existing user via a third-party provider.
     */
  }, {
    key: "exchangeCodeForSession",
    value: function exchangeCodeForSession(authCode) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var codeVerifier, _yield$_request, data, error;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return getItemAsync(this.storage, "".concat(this.storageKey, "-code-verifier"));
            case 2:
              codeVerifier = _context5.sent;
              _context5.next = 5;
              return _request(this.fetch, 'POST', "".concat(this.url, "/token?grant_type=pkce"), {
                headers: this.headers,
                body: {
                  auth_code: authCode,
                  code_verifier: codeVerifier
                },
                xform: _sessionResponse
              });
            case 5:
              _yield$_request = _context5.sent;
              data = _yield$_request.data;
              error = _yield$_request.error;
              _context5.next = 10;
              return removeItemAsync(this.storage, "".concat(this.storageKey, "-code-verifier"));
            case 10:
              if (!(error || !data)) {
                _context5.next = 12;
                break;
              }
              return _context5.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: error
              });
            case 12:
              if (!data.session) {
                _context5.next = 16;
                break;
              }
              _context5.next = 15;
              return this._saveSession(data.session);
            case 15:
              this._notifyAllSubscribers('SIGNED_IN', data.session);
            case 16:
              return _context5.abrupt("return", {
                data: data,
                error: error
              });
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
    /**
     * Allows signing in with an ID token issued by certain supported providers.
     * The ID token is verified for validity and a new session is established.
     *
     * @experimental
     */
  }, {
    key: "signInWithIdToken",
    value: function signInWithIdToken(credentials) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var options, provider, token, nonce, res, data, error;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this._removeSession();
            case 2:
              _context6.prev = 2;
              options = credentials.options, provider = credentials.provider, token = credentials.token, nonce = credentials.nonce;
              _context6.next = 6;
              return _request(this.fetch, 'POST', "".concat(this.url, "/token?grant_type=id_token"), {
                headers: this.headers,
                body: {
                  provider: provider,
                  id_token: token,
                  nonce: nonce,
                  gotrue_meta_security: {
                    captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                  }
                },
                xform: _sessionResponse
              });
            case 6:
              res = _context6.sent;
              data = res.data, error = res.error;
              if (!(error || !data)) {
                _context6.next = 10;
                break;
              }
              return _context6.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: error
              });
            case 10:
              if (!data.session) {
                _context6.next = 14;
                break;
              }
              _context6.next = 13;
              return this._saveSession(data.session);
            case 13:
              this._notifyAllSubscribers('SIGNED_IN', data.session);
            case 14:
              return _context6.abrupt("return", {
                data: data,
                error: error
              });
            case 17:
              _context6.prev = 17;
              _context6.t0 = _context6["catch"](2);
              if (!isAuthError(_context6.t0)) {
                _context6.next = 21;
                break;
              }
              return _context6.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: _context6.t0
              });
            case 21:
              throw _context6.t0;
            case 22:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[2, 17]]);
      }));
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     */
  }, {
    key: "signInWithOtp",
    value: function signInWithOtp(credentials) {
      var _a, _b, _c, _d, _e;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var email, options, _yield$_request2, error, phone, _options3, _yield$_request3, _error;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return this._removeSession();
            case 3:
              if (!('email' in credentials)) {
                _context7.next = 10;
                break;
              }
              email = credentials.email, options = credentials.options;
              _context7.next = 7;
              return _request(this.fetch, 'POST', "".concat(this.url, "/otp"), {
                headers: this.headers,
                body: {
                  email: email,
                  data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                  create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                  gotrue_meta_security: {
                    captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                  }
                },
                redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
              });
            case 7:
              _yield$_request2 = _context7.sent;
              error = _yield$_request2.error;
              return _context7.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: error
              });
            case 10:
              if (!('phone' in credentials)) {
                _context7.next = 17;
                break;
              }
              phone = credentials.phone, _options3 = credentials.options;
              _context7.next = 14;
              return _request(this.fetch, 'POST', "".concat(this.url, "/otp"), {
                headers: this.headers,
                body: {
                  phone: phone,
                  data: (_c = _options3 === null || _options3 === void 0 ? void 0 : _options3.data) !== null && _c !== void 0 ? _c : {},
                  create_user: (_d = _options3 === null || _options3 === void 0 ? void 0 : _options3.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                  gotrue_meta_security: {
                    captcha_token: _options3 === null || _options3 === void 0 ? void 0 : _options3.captchaToken
                  },
                  channel: (_e = _options3 === null || _options3 === void 0 ? void 0 : _options3.channel) !== null && _e !== void 0 ? _e : 'sms'
                }
              });
            case 14:
              _yield$_request3 = _context7.sent;
              _error = _yield$_request3.error;
              return _context7.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: _error
              });
            case 17:
              throw new AuthInvalidCredentialsError('You must provide either an email or phone number.');
            case 20:
              _context7.prev = 20;
              _context7.t0 = _context7["catch"](0);
              if (!isAuthError(_context7.t0)) {
                _context7.next = 24;
                break;
              }
              return _context7.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: _context7.t0
              });
            case 24:
              throw _context7.t0;
            case 25:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 20]]);
      }));
    }
    /**
     * Log in a user given a User supplied OTP received via mobile.
     */
  }, {
    key: "verifyOtp",
    value: function verifyOtp(params) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _yield$_request4, data, error, session, user;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this._removeSession();
            case 3:
              _context8.next = 5;
              return _request(this.fetch, 'POST', "".concat(this.url, "/verify"), {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                  gotrue_meta_security: {
                    captcha_token: (_a = params.options) === null || _a === void 0 ? void 0 : _a.captchaToken
                  }
                }),
                redirectTo: (_b = params.options) === null || _b === void 0 ? void 0 : _b.redirectTo,
                xform: _sessionResponse
              });
            case 5:
              _yield$_request4 = _context8.sent;
              data = _yield$_request4.data;
              error = _yield$_request4.error;
              if (!error) {
                _context8.next = 10;
                break;
              }
              throw error;
            case 10:
              if (data) {
                _context8.next = 12;
                break;
              }
              throw new Error('An error occurred on token verification.');
            case 12:
              session = data.session;
              user = data.user;
              if (!(session === null || session === void 0 ? void 0 : session.access_token)) {
                _context8.next = 18;
                break;
              }
              _context8.next = 17;
              return this._saveSession(session);
            case 17:
              this._notifyAllSubscribers('SIGNED_IN', session);
            case 18:
              return _context8.abrupt("return", {
                data: {
                  user: user,
                  session: session
                },
                error: null
              });
            case 21:
              _context8.prev = 21;
              _context8.t0 = _context8["catch"](0);
              if (!isAuthError(_context8.t0)) {
                _context8.next = 25;
                break;
              }
              return _context8.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: _context8.t0
              });
            case 25:
              throw _context8.t0;
            case 26:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 21]]);
      }));
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */
  }, {
    key: "signInWithSSO",
    value: function signInWithSSO(params) {
      var _a, _b, _c;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return this._removeSession();
            case 3:
              _context9.next = 5;
              return _request(this.fetch, 'POST', "".concat(this.url, "/sso"), {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                  provider_id: params.providerId
                } : null), 'domain' in params ? {
                  domain: params.domain
                } : null), {
                  redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                  gotrue_meta_security: {
                    captcha_token: params.options.captchaToken
                  }
                } : null), {
                  skip_http_redirect: true
                }),
                headers: this.headers,
                xform: _ssoResponse
              });
            case 5:
              return _context9.abrupt("return", _context9.sent);
            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](0);
              if (!isAuthError(_context9.t0)) {
                _context9.next = 12;
                break;
              }
              return _context9.abrupt("return", {
                data: null,
                error: _context9.t0
              });
            case 12:
              throw _context9.t0;
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[0, 8]]);
      }));
    }
    /**
     * Returns the session, refreshing it if necessary.
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     */
  }, {
    key: "getSession",
    value: function getSession() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var currentSession, maybeSession, hasExpired, _yield$this$_callRefr, session, error;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.initializePromise;
            case 2:
              currentSession = null;
              if (!this.persistSession) {
                _context10.next = 16;
                break;
              }
              _context10.next = 6;
              return getItemAsync(this.storage, this.storageKey);
            case 6:
              maybeSession = _context10.sent;
              if (!(maybeSession !== null)) {
                _context10.next = 14;
                break;
              }
              if (!this._isValidSession(maybeSession)) {
                _context10.next = 12;
                break;
              }
              currentSession = maybeSession;
              _context10.next = 14;
              break;
            case 12:
              _context10.next = 14;
              return this._removeSession();
            case 14:
              _context10.next = 17;
              break;
            case 16:
              currentSession = this.inMemorySession;
            case 17:
              if (currentSession) {
                _context10.next = 19;
                break;
              }
              return _context10.abrupt("return", {
                data: {
                  session: null
                },
                error: null
              });
            case 19:
              hasExpired = currentSession.expires_at ? currentSession.expires_at <= Date.now() / 1000 : false;
              if (hasExpired) {
                _context10.next = 22;
                break;
              }
              return _context10.abrupt("return", {
                data: {
                  session: currentSession
                },
                error: null
              });
            case 22:
              _context10.next = 24;
              return this._callRefreshToken(currentSession.refresh_token);
            case 24:
              _yield$this$_callRefr = _context10.sent;
              session = _yield$this$_callRefr.session;
              error = _yield$this$_callRefr.error;
              if (!error) {
                _context10.next = 29;
                break;
              }
              return _context10.abrupt("return", {
                data: {
                  session: null
                },
                error: error
              });
            case 29:
              return _context10.abrupt("return", {
                data: {
                  session: session
                },
                error: null
              });
            case 30:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
    /**
     * Gets the current user details if there is an existing session.
     * @param jwt Takes in an optional access token jwt. If no jwt is provided, getUser() will attempt to get the jwt from the current session.
     */
  }, {
    key: "getUser",
    value: function getUser(jwt) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _yield$this$getSessio, data, error;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              if (jwt) {
                _context11.next = 10;
                break;
              }
              _context11.next = 4;
              return this.getSession();
            case 4:
              _yield$this$getSessio = _context11.sent;
              data = _yield$this$getSessio.data;
              error = _yield$this$getSessio.error;
              if (!error) {
                _context11.next = 9;
                break;
              }
              throw error;
            case 9:
              // Default to Authorization header if there is no existing session
              jwt = (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined;
            case 10:
              _context11.next = 12;
              return _request(this.fetch, 'GET', "".concat(this.url, "/user"), {
                headers: this.headers,
                jwt: jwt,
                xform: _userResponse
              });
            case 12:
              return _context11.abrupt("return", _context11.sent);
            case 15:
              _context11.prev = 15;
              _context11.t0 = _context11["catch"](0);
              if (!isAuthError(_context11.t0)) {
                _context11.next = 19;
                break;
              }
              return _context11.abrupt("return", {
                data: {
                  user: null
                },
                error: _context11.t0
              });
            case 19:
              throw _context11.t0;
            case 20:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[0, 15]]);
      }));
    }
    /**
     * Updates user data for a logged in user.
     */
  }, {
    key: "updateUser",
    value: function updateUser(attributes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _yield$this$getSessio2, sessionData, sessionError, session, _yield$_request5, data, userError;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return this.getSession();
            case 3:
              _yield$this$getSessio2 = _context12.sent;
              sessionData = _yield$this$getSessio2.data;
              sessionError = _yield$this$getSessio2.error;
              if (!sessionError) {
                _context12.next = 8;
                break;
              }
              throw sessionError;
            case 8:
              if (sessionData.session) {
                _context12.next = 10;
                break;
              }
              throw new AuthSessionMissingError();
            case 10:
              session = sessionData.session;
              _context12.next = 13;
              return _request(this.fetch, 'PUT', "".concat(this.url, "/user"), {
                headers: this.headers,
                redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                body: attributes,
                jwt: session.access_token,
                xform: _userResponse
              });
            case 13:
              _yield$_request5 = _context12.sent;
              data = _yield$_request5.data;
              userError = _yield$_request5.error;
              if (!userError) {
                _context12.next = 18;
                break;
              }
              throw userError;
            case 18:
              session.user = data.user;
              _context12.next = 21;
              return this._saveSession(session);
            case 21:
              this._notifyAllSubscribers('USER_UPDATED', session);
              return _context12.abrupt("return", {
                data: {
                  user: session.user
                },
                error: null
              });
            case 25:
              _context12.prev = 25;
              _context12.t0 = _context12["catch"](0);
              if (!isAuthError(_context12.t0)) {
                _context12.next = 29;
                break;
              }
              return _context12.abrupt("return", {
                data: {
                  user: null
                },
                error: _context12.t0
              });
            case 29:
              throw _context12.t0;
            case 30:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[0, 25]]);
      }));
    }
    /**
     * Decodes a JWT (without performing any validation).
     */
  }, {
    key: "_decodeJWT",
    value: function _decodeJWT(jwt) {
      return decodeJWTPayload(jwt);
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */
  }, {
    key: "setSession",
    value: function setSession(currentSession) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var timeNow, expiresAt, hasExpired, session, payload, _yield$this$_callRefr2, refreshedSession, error, _yield$this$getUser, data, _error2;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              if (!(!currentSession.access_token || !currentSession.refresh_token)) {
                _context13.next = 3;
                break;
              }
              throw new AuthSessionMissingError();
            case 3:
              timeNow = Date.now() / 1000;
              expiresAt = timeNow;
              hasExpired = true;
              session = null;
              payload = decodeJWTPayload(currentSession.access_token);
              if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
              }
              if (!hasExpired) {
                _context13.next = 22;
                break;
              }
              _context13.next = 12;
              return this._callRefreshToken(currentSession.refresh_token);
            case 12:
              _yield$this$_callRefr2 = _context13.sent;
              refreshedSession = _yield$this$_callRefr2.session;
              error = _yield$this$_callRefr2.error;
              if (!error) {
                _context13.next = 17;
                break;
              }
              return _context13.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: error
              });
            case 17:
              if (refreshedSession) {
                _context13.next = 19;
                break;
              }
              return _context13.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: null
              });
            case 19:
              session = refreshedSession;
              _context13.next = 33;
              break;
            case 22:
              _context13.next = 24;
              return this.getUser(currentSession.access_token);
            case 24:
              _yield$this$getUser = _context13.sent;
              data = _yield$this$getUser.data;
              _error2 = _yield$this$getUser.error;
              if (!_error2) {
                _context13.next = 29;
                break;
              }
              throw _error2;
            case 29:
              session = {
                access_token: currentSession.access_token,
                refresh_token: currentSession.refresh_token,
                user: data.user,
                token_type: 'bearer',
                expires_in: expiresAt - timeNow,
                expires_at: expiresAt
              };
              _context13.next = 32;
              return this._saveSession(session);
            case 32:
              this._notifyAllSubscribers('SIGNED_IN', session);
            case 33:
              return _context13.abrupt("return", {
                data: {
                  user: session.user,
                  session: session
                },
                error: null
              });
            case 36:
              _context13.prev = 36;
              _context13.t0 = _context13["catch"](0);
              if (!isAuthError(_context13.t0)) {
                _context13.next = 40;
                break;
              }
              return _context13.abrupt("return", {
                data: {
                  session: null,
                  user: null
                },
                error: _context13.t0
              });
            case 40:
              throw _context13.t0;
            case 41:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[0, 36]]);
      }));
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */
  }, {
    key: "refreshSession",
    value: function refreshSession(currentSession) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _yield$this$getSessio3, data, _error3, _yield$this$_callRefr3, session, error;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              if (currentSession) {
                _context14.next = 10;
                break;
              }
              _context14.next = 4;
              return this.getSession();
            case 4:
              _yield$this$getSessio3 = _context14.sent;
              data = _yield$this$getSessio3.data;
              _error3 = _yield$this$getSessio3.error;
              if (!_error3) {
                _context14.next = 9;
                break;
              }
              throw _error3;
            case 9:
              currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
            case 10:
              if (currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token) {
                _context14.next = 12;
                break;
              }
              throw new AuthSessionMissingError();
            case 12:
              _context14.next = 14;
              return this._callRefreshToken(currentSession.refresh_token);
            case 14:
              _yield$this$_callRefr3 = _context14.sent;
              session = _yield$this$_callRefr3.session;
              error = _yield$this$_callRefr3.error;
              if (!error) {
                _context14.next = 19;
                break;
              }
              return _context14.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: error
              });
            case 19:
              if (session) {
                _context14.next = 21;
                break;
              }
              return _context14.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: null
              });
            case 21:
              return _context14.abrupt("return", {
                data: {
                  user: session.user,
                  session: session
                },
                error: null
              });
            case 24:
              _context14.prev = 24;
              _context14.t0 = _context14["catch"](0);
              if (!isAuthError(_context14.t0)) {
                _context14.next = 28;
                break;
              }
              return _context14.abrupt("return", {
                data: {
                  user: null,
                  session: null
                },
                error: _context14.t0
              });
            case 28:
              throw _context14.t0;
            case 29:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this, [[0, 24]]);
      }));
    }
    /**
     * Gets the session data from a URL string
     */
  }, {
    key: "_getSessionFromUrl",
    value: function _getSessionFromUrl(isPKCEFlow) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var authCode, _yield$this$exchangeC, _data, _error4, error_description, error_code, _error5, provider_token, provider_refresh_token, access_token, expires_in, refresh_token, token_type, timeNow, expires_at, _yield$this$getUser2, data, error, user, session, redirectType;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              if (isBrowser()) {
                _context15.next = 3;
                break;
              }
              throw new AuthImplicitGrantRedirectError('No browser detected.');
            case 3:
              if (!(this.flowType == 'implicit' && !this._isImplicitGrantFlow())) {
                _context15.next = 7;
                break;
              }
              throw new AuthImplicitGrantRedirectError('Not a valid implicit grant flow url.');
            case 7:
              if (!(this.flowType == 'pkce' && !isPKCEFlow)) {
                _context15.next = 9;
                break;
              }
              throw new AuthPKCEGrantCodeExchangeError('Not a valid PKCE flow url.');
            case 9:
              if (!isPKCEFlow) {
                _context15.next = 23;
                break;
              }
              authCode = getParameterByName('code');
              if (authCode) {
                _context15.next = 13;
                break;
              }
              throw new AuthPKCEGrantCodeExchangeError('No code detected.');
            case 13:
              _context15.next = 15;
              return this.exchangeCodeForSession(authCode);
            case 15:
              _yield$this$exchangeC = _context15.sent;
              _data = _yield$this$exchangeC.data;
              _error4 = _yield$this$exchangeC.error;
              if (!_error4) {
                _context15.next = 20;
                break;
              }
              throw _error4;
            case 20:
              if (_data.session) {
                _context15.next = 22;
                break;
              }
              throw new AuthPKCEGrantCodeExchangeError('No session detected.');
            case 22:
              return _context15.abrupt("return", {
                data: {
                  session: _data.session,
                  redirectType: null
                },
                error: null
              });
            case 23:
              error_description = getParameterByName('error_description');
              if (!error_description) {
                _context15.next = 32;
                break;
              }
              error_code = getParameterByName('error_code');
              if (error_code) {
                _context15.next = 28;
                break;
              }
              throw new AuthImplicitGrantRedirectError('No error_code detected.');
            case 28:
              _error5 = getParameterByName('error');
              if (_error5) {
                _context15.next = 31;
                break;
              }
              throw new AuthImplicitGrantRedirectError('No error detected.');
            case 31:
              throw new AuthImplicitGrantRedirectError(error_description, {
                error: _error5,
                code: error_code
              });
            case 32:
              provider_token = getParameterByName('provider_token');
              provider_refresh_token = getParameterByName('provider_refresh_token');
              access_token = getParameterByName('access_token');
              if (access_token) {
                _context15.next = 37;
                break;
              }
              throw new AuthImplicitGrantRedirectError('No access_token detected.');
            case 37:
              expires_in = getParameterByName('expires_in');
              if (expires_in) {
                _context15.next = 40;
                break;
              }
              throw new AuthImplicitGrantRedirectError('No expires_in detected.');
            case 40:
              refresh_token = getParameterByName('refresh_token');
              if (refresh_token) {
                _context15.next = 43;
                break;
              }
              throw new AuthImplicitGrantRedirectError('No refresh_token detected.');
            case 43:
              token_type = getParameterByName('token_type');
              if (token_type) {
                _context15.next = 46;
                break;
              }
              throw new AuthImplicitGrantRedirectError('No token_type detected.');
            case 46:
              timeNow = Math.round(Date.now() / 1000);
              expires_at = timeNow + parseInt(expires_in);
              _context15.next = 50;
              return this.getUser(access_token);
            case 50:
              _yield$this$getUser2 = _context15.sent;
              data = _yield$this$getUser2.data;
              error = _yield$this$getUser2.error;
              if (!error) {
                _context15.next = 55;
                break;
              }
              throw error;
            case 55:
              user = data.user;
              session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: parseInt(expires_in),
                expires_at: expires_at,
                refresh_token: refresh_token,
                token_type: token_type,
                user: user
              };
              redirectType = getParameterByName('type'); // Remove tokens from URL
              window.location.hash = '';
              return _context15.abrupt("return", {
                data: {
                  session: session,
                  redirectType: redirectType
                },
                error: null
              });
            case 62:
              _context15.prev = 62;
              _context15.t0 = _context15["catch"](0);
              if (!isAuthError(_context15.t0)) {
                _context15.next = 66;
                break;
              }
              return _context15.abrupt("return", {
                data: {
                  session: null,
                  redirectType: null
                },
                error: _context15.t0
              });
            case 66:
              throw _context15.t0;
            case 67:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[0, 62]]);
      }));
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */
  }, {
    key: "_isImplicitGrantFlow",
    value: function _isImplicitGrantFlow() {
      return isBrowser() && (Boolean(getParameterByName('access_token')) || Boolean(getParameterByName('error_description')));
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */
  }, {
    key: "_isPKCEFlow",
    value: function _isPKCEFlow() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var currentStorageContent;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return getItemAsync(this.storage, "".concat(this.storageKey, "-code-verifier"));
            case 2:
              currentStorageContent = _context16.sent;
              return _context16.abrupt("return", isBrowser() && Boolean(getParameterByName('code')) && Boolean(currentStorageContent));
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session
     * and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     */
  }, {
    key: "signOut",
    value: function signOut() {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _yield$this$getSessio4, data, sessionError, accessToken, _yield$this$admin$sig, error;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.getSession();
            case 2:
              _yield$this$getSessio4 = _context17.sent;
              data = _yield$this$getSessio4.data;
              sessionError = _yield$this$getSessio4.error;
              if (!sessionError) {
                _context17.next = 7;
                break;
              }
              return _context17.abrupt("return", {
                error: sessionError
              });
            case 7:
              accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
              if (!accessToken) {
                _context17.next = 16;
                break;
              }
              _context17.next = 11;
              return this.admin.signOut(accessToken);
            case 11:
              _yield$this$admin$sig = _context17.sent;
              error = _yield$this$admin$sig.error;
              if (!error) {
                _context17.next = 16;
                break;
              }
              if (isAuthApiError(error) && (error.status === 404 || error.status === 401)) {
                _context17.next = 16;
                break;
              }
              return _context17.abrupt("return", {
                error: error
              });
            case 16:
              _context17.next = 18;
              return this._removeSession();
            case 18:
              this._notifyAllSubscribers('SIGNED_OUT', null);
              return _context17.abrupt("return", {
                error: null
              });
            case 20:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */
  }, {
    key: "onAuthStateChange",
    value: function onAuthStateChange(callback) {
      var _this3 = this;
      var id = uuid();
      var subscription = {
        id: id,
        callback: callback,
        unsubscribe: function unsubscribe() {
          _this3.stateChangeEmitters.delete(id);
        }
      };
      this.stateChangeEmitters.set(id, subscription);
      this.emitInitialSession(id);
      return {
        data: {
          subscription: subscription
        }
      };
    }
  }, {
    key: "emitInitialSession",
    value: function emitInitialSession(id) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _yield$this$getSessio5, session, error;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return this.getSession();
            case 3:
              _yield$this$getSessio5 = _context18.sent;
              session = _yield$this$getSessio5.data.session;
              error = _yield$this$getSessio5.error;
              if (!error) {
                _context18.next = 8;
                break;
              }
              throw error;
            case 8:
              (_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session);
              _context18.next = 15;
              break;
            case 11:
              _context18.prev = 11;
              _context18.t0 = _context18["catch"](0);
              (_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null);
              console.error(_context18.t0);
            case 15:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this, [[0, 11]]);
      }));
    }
    /**
     * Sends a password reset request to an email address.
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */
  }, {
    key: "resetPasswordForEmail",
    value: function resetPasswordForEmail(email) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return _request(this.fetch, 'POST', "".concat(this.url, "/recover"), {
                body: {
                  email: email,
                  gotrue_meta_security: {
                    captcha_token: options.captchaToken
                  }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
              });
            case 3:
              return _context19.abrupt("return", _context19.sent);
            case 6:
              _context19.prev = 6;
              _context19.t0 = _context19["catch"](0);
              if (!isAuthError(_context19.t0)) {
                _context19.next = 10;
                break;
              }
              return _context19.abrupt("return", {
                data: null,
                error: _context19.t0
              });
            case 10:
              throw _context19.t0;
            case 11:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this, [[0, 6]]);
      }));
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */
  }, {
    key: "_refreshAccessToken",
    value: function _refreshAccessToken(refreshToken) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var _this4 = this;
        var startedAt;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.prev = 0;
              startedAt = Date.now(); // will attempt to refresh the token with exponential backoff
              _context21.next = 4;
              return retryable(function (attempt) {
                return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
                  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                    while (1) switch (_context20.prev = _context20.next) {
                      case 0:
                        _context20.next = 2;
                        return sleep(attempt * 200);
                      case 2:
                        _context20.next = 4;
                        return _request(this.fetch, 'POST', "".concat(this.url, "/token?grant_type=refresh_token"), {
                          body: {
                            refresh_token: refreshToken
                          },
                          headers: this.headers,
                          xform: _sessionResponse
                        });
                      case 4:
                        return _context20.abrupt("return", _context20.sent);
                      case 5:
                      case "end":
                        return _context20.stop();
                    }
                  }, _callee20, this);
                }));
              }, function (attempt, _, result) {
                return result && result.error && result.error instanceof AuthRetryableFetchError &&
                // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + (attempt + 1) * 200 - startedAt < AUTO_REFRESH_TICK_DURATION;
              });
            case 4:
              return _context21.abrupt("return", _context21.sent);
            case 7:
              _context21.prev = 7;
              _context21.t0 = _context21["catch"](0);
              if (!isAuthError(_context21.t0)) {
                _context21.next = 11;
                break;
              }
              return _context21.abrupt("return", {
                data: {
                  session: null,
                  user: null
                },
                error: _context21.t0
              });
            case 11:
              throw _context21.t0;
            case 12:
            case "end":
              return _context21.stop();
          }
        }, _callee21, null, [[0, 7]]);
      }));
    }
  }, {
    key: "_isValidSession",
    value: function _isValidSession(maybeSession) {
      var isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
      return isValidSession;
    }
  }, {
    key: "_handleProviderSignIn",
    value: function _handleProviderSignIn(provider, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var url;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return this._getUrlForProvider(provider, {
                redirectTo: options.redirectTo,
                scopes: options.scopes,
                queryParams: options.queryParams,
                flowType: options.flowType
              });
            case 2:
              url = _context22.sent;
              // try to open on the browser
              if (isBrowser() && !options.skipBrowserRedirect) {
                window.location.assign(url);
              }
              return _context22.abrupt("return", {
                data: {
                  provider: provider,
                  url: url
                },
                error: null
              });
            case 5:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
    }
    /**
     * Recovers the session from LocalStorage and refreshes
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */
  }, {
    key: "_recoverAndRefresh",
    value: function _recoverAndRefresh() {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var currentSession, timeNow, _yield$this$_callRefr4, error;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              _context23.next = 3;
              return getItemAsync(this.storage, this.storageKey);
            case 3:
              currentSession = _context23.sent;
              if (this._isValidSession(currentSession)) {
                _context23.next = 9;
                break;
              }
              if (!(currentSession !== null)) {
                _context23.next = 8;
                break;
              }
              _context23.next = 8;
              return this._removeSession();
            case 8:
              return _context23.abrupt("return");
            case 9:
              timeNow = Math.round(Date.now() / 1000);
              if (!(((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) < timeNow + EXPIRY_MARGIN)) {
                _context23.next = 26;
                break;
              }
              if (!(this.autoRefreshToken && currentSession.refresh_token)) {
                _context23.next = 22;
                break;
              }
              _context23.next = 14;
              return this._callRefreshToken(currentSession.refresh_token);
            case 14:
              _yield$this$_callRefr4 = _context23.sent;
              error = _yield$this$_callRefr4.error;
              if (!error) {
                _context23.next = 20;
                break;
              }
              console.log(error.message);
              _context23.next = 20;
              return this._removeSession();
            case 20:
              _context23.next = 24;
              break;
            case 22:
              _context23.next = 24;
              return this._removeSession();
            case 24:
              _context23.next = 30;
              break;
            case 26:
              if (!this.persistSession) {
                _context23.next = 29;
                break;
              }
              _context23.next = 29;
              return this._saveSession(currentSession);
            case 29:
              this._notifyAllSubscribers('SIGNED_IN', currentSession);
            case 30:
              _context23.next = 36;
              break;
            case 32:
              _context23.prev = 32;
              _context23.t0 = _context23["catch"](0);
              console.error(_context23.t0);
              return _context23.abrupt("return");
            case 36:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this, [[0, 32]]);
      }));
    }
  }, {
    key: "_callRefreshToken",
    value: function _callRefreshToken(refreshToken) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var _yield$this$_refreshA, data, error, result, _result;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (!this.refreshingDeferred) {
                _context24.next = 2;
                break;
              }
              return _context24.abrupt("return", this.refreshingDeferred.promise);
            case 2:
              _context24.prev = 2;
              this.refreshingDeferred = new Deferred();
              if (refreshToken) {
                _context24.next = 6;
                break;
              }
              throw new AuthSessionMissingError();
            case 6:
              _context24.next = 8;
              return this._refreshAccessToken(refreshToken);
            case 8:
              _yield$this$_refreshA = _context24.sent;
              data = _yield$this$_refreshA.data;
              error = _yield$this$_refreshA.error;
              if (!error) {
                _context24.next = 13;
                break;
              }
              throw error;
            case 13:
              if (data.session) {
                _context24.next = 15;
                break;
              }
              throw new AuthSessionMissingError();
            case 15:
              _context24.next = 17;
              return this._saveSession(data.session);
            case 17:
              this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
              result = {
                session: data.session,
                error: null
              };
              this.refreshingDeferred.resolve(result);
              return _context24.abrupt("return", result);
            case 23:
              _context24.prev = 23;
              _context24.t0 = _context24["catch"](2);
              if (!isAuthError(_context24.t0)) {
                _context24.next = 29;
                break;
              }
              _result = {
                session: null,
                error: _context24.t0
              };
              (_a = this.refreshingDeferred) === null || _a === void 0 ? void 0 : _a.resolve(_result);
              return _context24.abrupt("return", _result);
            case 29:
              (_b = this.refreshingDeferred) === null || _b === void 0 ? void 0 : _b.reject(_context24.t0);
              throw _context24.t0;
            case 31:
              _context24.prev = 31;
              this.refreshingDeferred = null;
              return _context24.finish(31);
            case 34:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this, [[2, 23, 31, 34]]);
      }));
    }
  }, {
    key: "_notifyAllSubscribers",
    value: function _notifyAllSubscribers(event, session) {
      var broadcast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (this.broadcastChannel && broadcast) {
        this.broadcastChannel.postMessage({
          event: event,
          session: session
        });
      }
      this.stateChangeEmitters.forEach(function (x) {
        return x.callback(event, session);
      });
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */
  }, {
    key: "_saveSession",
    value: function _saveSession(session) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (!this.persistSession) {
                this.inMemorySession = session;
              }
              if (!(this.persistSession && session.expires_at)) {
                _context25.next = 4;
                break;
              }
              _context25.next = 4;
              return this._persistSession(session);
            case 4:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
    }
  }, {
    key: "_persistSession",
    value: function _persistSession(currentSession) {
      return setItemAsync(this.storage, this.storageKey, currentSession);
    }
  }, {
    key: "_removeSession",
    value: function _removeSession() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!this.persistSession) {
                _context26.next = 5;
                break;
              }
              _context26.next = 3;
              return removeItemAsync(this.storage, this.storageKey);
            case 3:
              _context26.next = 6;
              break;
            case 5:
              this.inMemorySession = null;
            case 6:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */
  }, {
    key: "_removeVisibilityChangedCallback",
    value: function _removeVisibilityChangedCallback() {
      var callback = this.visibilityChangedCallback;
      this.visibilityChangedCallback = null;
      try {
        if (callback && isBrowser() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) {
          window.removeEventListener('visibilitychange', callback);
        }
      } catch (e) {
        console.error('removing visibilitychange callback failed', e);
      }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */
  }, {
    key: "_startAutoRefresh",
    value: function _startAutoRefresh() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var _this5 = this;
        var ticker;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return this._stopAutoRefresh();
            case 2:
              ticker = setInterval(function () {
                return _this5._autoRefreshTokenTick();
              }, AUTO_REFRESH_TICK_DURATION);
              this.autoRefreshTicker = ticker;
              if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') {
                // ticker is a NodeJS Timeout object that has an `unref` method
                // https://nodejs.org/api/timers.html#timeoutunref
                // When auto refresh is used in NodeJS (like for testing) the
                // `setInterval` is preventing the process from being marked as
                // finished and tests run endlessly. This can be prevented by calling
                // `unref()` on the returned object.
                ticker.unref();
              }
              // run the tick immediately
              _context27.next = 7;
              return this._autoRefreshTokenTick();
            case 7:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */
  }, {
    key: "_stopAutoRefresh",
    value: function _stopAutoRefresh() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var ticker;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              ticker = this.autoRefreshTicker;
              this.autoRefreshTicker = null;
              if (ticker) {
                clearInterval(ticker);
              }
            case 3:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desireable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */
  }, {
    key: "startAutoRefresh",
    value: function startAutoRefresh() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              this._removeVisibilityChangedCallback();
              _context29.next = 3;
              return this._startAutoRefresh();
            case 3:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */
  }, {
    key: "stopAutoRefresh",
    value: function stopAutoRefresh() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              this._removeVisibilityChangedCallback();
              _context30.next = 3;
              return this._stopAutoRefresh();
            case 3:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
    }
    /**
     * Runs the auto refresh token tick.
     */
  }, {
    key: "_autoRefreshTokenTick",
    value: function _autoRefreshTokenTick() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var now, _yield$this$getSessio6, session, expiresInTicks;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              now = Date.now();
              _context31.prev = 1;
              _context31.next = 4;
              return this.getSession();
            case 4:
              _yield$this$getSessio6 = _context31.sent;
              session = _yield$this$getSessio6.data.session;
              if (!(!session || !session.refresh_token || !session.expires_at)) {
                _context31.next = 8;
                break;
              }
              return _context31.abrupt("return");
            case 8:
              // session will expire in this many ticks (or has already expired if <= 0)
              expiresInTicks = Math.floor((session.expires_at * 1000 - now) / AUTO_REFRESH_TICK_DURATION);
              if (!(expiresInTicks < AUTO_REFRESH_TICK_THRESHOLD)) {
                _context31.next = 12;
                break;
              }
              _context31.next = 12;
              return this._callRefreshToken(session.refresh_token);
            case 12:
              _context31.next = 17;
              break;
            case 14:
              _context31.prev = 14;
              _context31.t0 = _context31["catch"](1);
              console.error('Auto refresh tick failed with error. This is likely a transient error.', _context31.t0);
            case 17:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this, [[1, 14]]);
      }));
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */
  }, {
    key: "_handleVisibilityChange",
    value: function _handleVisibilityChange() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (!(!isBrowser() || !(window === null || window === void 0 ? void 0 : window.addEventListener))) {
                _context33.next = 3;
                break;
              }
              if (this.autoRefreshToken) {
                // in non-browser environments the refresh token ticker runs always
                this.startAutoRefresh();
              }
              return _context33.abrupt("return", false);
            case 3:
              _context33.prev = 3;
              this.visibilityChangedCallback = function () {
                return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
                  return _regeneratorRuntime().wrap(function _callee32$(_context32) {
                    while (1) switch (_context32.prev = _context32.next) {
                      case 0:
                        _context32.next = 2;
                        return this._onVisibilityChanged(false);
                      case 2:
                        return _context32.abrupt("return", _context32.sent);
                      case 3:
                      case "end":
                        return _context32.stop();
                    }
                  }, _callee32, this);
                }));
              };
              window === null || window === void 0 ? void 0 : window.addEventListener('visibilitychange', this.visibilityChangedCallback);
              // now immediately call the visbility changed callback to setup with the
              // current visbility state
              _context33.next = 8;
              return this._onVisibilityChanged(true);
            case 8:
              _context33.next = 13;
              break;
            case 10:
              _context33.prev = 10;
              _context33.t0 = _context33["catch"](3);
              console.error('_handleVisibilityChange', _context33.t0);
            case 13:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this, [[3, 10]]);
      }));
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */
  }, {
    key: "_onVisibilityChanged",
    value: function _onVisibilityChanged(isInitial) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              if (!(document.visibilityState === 'visible')) {
                _context34.next = 9;
                break;
              }
              if (isInitial) {
                _context34.next = 6;
                break;
              }
              _context34.next = 4;
              return this.initializePromise;
            case 4:
              _context34.next = 6;
              return this._recoverAndRefresh();
            case 6:
              if (this.autoRefreshToken) {
                // in browser environments the refresh token ticker runs only on focused tabs
                // which prevents race conditions
                this._startAutoRefresh();
              }
              _context34.next = 10;
              break;
            case 9:
              if (document.visibilityState === 'hidden') {
                if (this.autoRefreshToken) {
                  this._stopAutoRefresh();
                }
              }
            case 10:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     * @param options.flowType OAuth flow to use - defaults to implicit flow. PKCE is recommended for mobile and server-side applications.
     */
  }, {
    key: "_getUrlForProvider",
    value: function _getUrlForProvider(provider, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var urlParams, codeVerifier, codeChallenge, flowParams, query;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              urlParams = ["provider=".concat(encodeURIComponent(provider))];
              if (options === null || options === void 0 ? void 0 : options.redirectTo) {
                urlParams.push("redirect_to=".concat(encodeURIComponent(options.redirectTo)));
              }
              if (options === null || options === void 0 ? void 0 : options.scopes) {
                urlParams.push("scopes=".concat(encodeURIComponent(options.scopes)));
              }
              if (!((options === null || options === void 0 ? void 0 : options.flowType) === 'pkce')) {
                _context35.next = 12;
                break;
              }
              codeVerifier = generatePKCEVerifier();
              _context35.next = 7;
              return setItemAsync(this.storage, "".concat(this.storageKey, "-code-verifier"), codeVerifier);
            case 7:
              _context35.next = 9;
              return generatePKCEChallenge(codeVerifier);
            case 9:
              codeChallenge = _context35.sent;
              flowParams = new URLSearchParams({
                flow_type: "".concat(encodeURIComponent(options.flowType)),
                code_challenge: "".concat(encodeURIComponent(codeChallenge)),
                code_challenge_method: "".concat(encodeURIComponent('s256'))
              });
              urlParams.push(flowParams.toString());
            case 12:
              if (options === null || options === void 0 ? void 0 : options.queryParams) {
                query = new URLSearchParams(options.queryParams);
                urlParams.push(query.toString());
              }
              return _context35.abrupt("return", "".concat(this.url, "/authorize?").concat(urlParams.join('&')));
            case 14:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
    }
  }, {
    key: "_unenroll",
    value: function _unenroll(params) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var _yield$this$getSessio7, sessionData, sessionError;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.prev = 0;
              _context36.next = 3;
              return this.getSession();
            case 3:
              _yield$this$getSessio7 = _context36.sent;
              sessionData = _yield$this$getSessio7.data;
              sessionError = _yield$this$getSessio7.error;
              if (!sessionError) {
                _context36.next = 8;
                break;
              }
              return _context36.abrupt("return", {
                data: null,
                error: sessionError
              });
            case 8:
              _context36.next = 10;
              return _request(this.fetch, 'DELETE', "".concat(this.url, "/factors/").concat(params.factorId), {
                headers: this.headers,
                jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
              });
            case 10:
              return _context36.abrupt("return", _context36.sent);
            case 13:
              _context36.prev = 13;
              _context36.t0 = _context36["catch"](0);
              if (!isAuthError(_context36.t0)) {
                _context36.next = 17;
                break;
              }
              return _context36.abrupt("return", {
                data: null,
                error: _context36.t0
              });
            case 17:
              throw _context36.t0;
            case 18:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this, [[0, 13]]);
      }));
    }
    /**
     * {@see GoTrueMFAApi#enroll}
     */
  }, {
    key: "_enroll",
    value: function _enroll(params) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var _yield$this$getSessio8, sessionData, sessionError, _yield$_request6, data, error;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.prev = 0;
              _context37.next = 3;
              return this.getSession();
            case 3:
              _yield$this$getSessio8 = _context37.sent;
              sessionData = _yield$this$getSessio8.data;
              sessionError = _yield$this$getSessio8.error;
              if (!sessionError) {
                _context37.next = 8;
                break;
              }
              return _context37.abrupt("return", {
                data: null,
                error: sessionError
              });
            case 8:
              _context37.next = 10;
              return _request(this.fetch, 'POST', "".concat(this.url, "/factors"), {
                body: {
                  friendly_name: params.friendlyName,
                  factor_type: params.factorType,
                  issuer: params.issuer
                },
                headers: this.headers,
                jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
              });
            case 10:
              _yield$_request6 = _context37.sent;
              data = _yield$_request6.data;
              error = _yield$_request6.error;
              if (!error) {
                _context37.next = 15;
                break;
              }
              return _context37.abrupt("return", {
                data: null,
                error: error
              });
            case 15:
              if ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code) {
                data.totp.qr_code = "data:image/svg+xml;utf-8,".concat(data.totp.qr_code);
              }
              return _context37.abrupt("return", {
                data: data,
                error: null
              });
            case 19:
              _context37.prev = 19;
              _context37.t0 = _context37["catch"](0);
              if (!isAuthError(_context37.t0)) {
                _context37.next = 23;
                break;
              }
              return _context37.abrupt("return", {
                data: null,
                error: _context37.t0
              });
            case 23:
              throw _context37.t0;
            case 24:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this, [[0, 19]]);
      }));
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */
  }, {
    key: "_verify",
    value: function _verify(params) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        var _yield$this$getSessio9, sessionData, sessionError, _yield$_request7, data, error;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              _context38.prev = 0;
              _context38.next = 3;
              return this.getSession();
            case 3:
              _yield$this$getSessio9 = _context38.sent;
              sessionData = _yield$this$getSessio9.data;
              sessionError = _yield$this$getSessio9.error;
              if (!sessionError) {
                _context38.next = 8;
                break;
              }
              return _context38.abrupt("return", {
                data: null,
                error: sessionError
              });
            case 8:
              _context38.next = 10;
              return _request(this.fetch, 'POST', "".concat(this.url, "/factors/").concat(params.factorId, "/verify"), {
                body: {
                  code: params.code,
                  challenge_id: params.challengeId
                },
                headers: this.headers,
                jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
              });
            case 10:
              _yield$_request7 = _context38.sent;
              data = _yield$_request7.data;
              error = _yield$_request7.error;
              if (!error) {
                _context38.next = 15;
                break;
              }
              return _context38.abrupt("return", {
                data: null,
                error: error
              });
            case 15:
              _context38.next = 17;
              return this._saveSession(Object.assign({
                expires_at: Math.round(Date.now() / 1000) + data.expires_in
              }, data));
            case 17:
              this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
              return _context38.abrupt("return", {
                data: data,
                error: error
              });
            case 21:
              _context38.prev = 21;
              _context38.t0 = _context38["catch"](0);
              if (!isAuthError(_context38.t0)) {
                _context38.next = 25;
                break;
              }
              return _context38.abrupt("return", {
                data: null,
                error: _context38.t0
              });
            case 25:
              throw _context38.t0;
            case 26:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this, [[0, 21]]);
      }));
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */
  }, {
    key: "_challenge",
    value: function _challenge(params) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var _yield$this$getSessio10, sessionData, sessionError;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _context39.prev = 0;
              _context39.next = 3;
              return this.getSession();
            case 3:
              _yield$this$getSessio10 = _context39.sent;
              sessionData = _yield$this$getSessio10.data;
              sessionError = _yield$this$getSessio10.error;
              if (!sessionError) {
                _context39.next = 8;
                break;
              }
              return _context39.abrupt("return", {
                data: null,
                error: sessionError
              });
            case 8:
              _context39.next = 10;
              return _request(this.fetch, 'POST', "".concat(this.url, "/factors/").concat(params.factorId, "/challenge"), {
                headers: this.headers,
                jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
              });
            case 10:
              return _context39.abrupt("return", _context39.sent);
            case 13:
              _context39.prev = 13;
              _context39.t0 = _context39["catch"](0);
              if (!isAuthError(_context39.t0)) {
                _context39.next = 17;
                break;
              }
              return _context39.abrupt("return", {
                data: null,
                error: _context39.t0
              });
            case 17:
              throw _context39.t0;
            case 18:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this, [[0, 13]]);
      }));
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */
  }, {
    key: "_challengeAndVerify",
    value: function _challengeAndVerify(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var _yield$this$_challeng, challengeData, challengeError;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return this._challenge({
                factorId: params.factorId
              });
            case 2:
              _yield$this$_challeng = _context40.sent;
              challengeData = _yield$this$_challeng.data;
              challengeError = _yield$this$_challeng.error;
              if (!challengeError) {
                _context40.next = 7;
                break;
              }
              return _context40.abrupt("return", {
                data: null,
                error: challengeError
              });
            case 7:
              _context40.next = 9;
              return this._verify({
                factorId: params.factorId,
                challengeId: challengeData.id,
                code: params.code
              });
            case 9:
              return _context40.abrupt("return", _context40.sent);
            case 10:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this);
      }));
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */
  }, {
    key: "_listFactors",
    value: function _listFactors() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var _yield$this$getUser3, user, userError, factors, totp;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return this.getUser();
            case 2:
              _yield$this$getUser3 = _context41.sent;
              user = _yield$this$getUser3.data.user;
              userError = _yield$this$getUser3.error;
              if (!userError) {
                _context41.next = 7;
                break;
              }
              return _context41.abrupt("return", {
                data: null,
                error: userError
              });
            case 7:
              factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
              totp = factors.filter(function (factor) {
                return factor.factor_type === 'totp' && factor.status === 'verified';
              });
              return _context41.abrupt("return", {
                data: {
                  all: factors,
                  totp: totp
                },
                error: null
              });
            case 10:
            case "end":
              return _context41.stop();
          }
        }, _callee41, this);
      }));
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */
  }, {
    key: "_getAuthenticatorAssuranceLevel",
    value: function _getAuthenticatorAssuranceLevel() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var _yield$this$getSessio11, session, sessionError, payload, currentLevel, nextLevel, verifiedFactors, currentAuthenticationMethods;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return this.getSession();
            case 2:
              _yield$this$getSessio11 = _context42.sent;
              session = _yield$this$getSessio11.data.session;
              sessionError = _yield$this$getSessio11.error;
              if (!sessionError) {
                _context42.next = 7;
                break;
              }
              return _context42.abrupt("return", {
                data: null,
                error: sessionError
              });
            case 7:
              if (session) {
                _context42.next = 9;
                break;
              }
              return _context42.abrupt("return", {
                data: {
                  currentLevel: null,
                  nextLevel: null,
                  currentAuthenticationMethods: []
                },
                error: null
              });
            case 9:
              payload = this._decodeJWT(session.access_token);
              currentLevel = null;
              if (payload.aal) {
                currentLevel = payload.aal;
              }
              nextLevel = currentLevel;
              verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter(function (factor) {
                return factor.status === 'verified';
              })) !== null && _b !== void 0 ? _b : [];
              if (verifiedFactors.length > 0) {
                nextLevel = 'aal2';
              }
              currentAuthenticationMethods = payload.amr || [];
              return _context42.abrupt("return", {
                data: {
                  currentLevel: currentLevel,
                  nextLevel: nextLevel,
                  currentAuthenticationMethods: currentAuthenticationMethods
                },
                error: null
              });
            case 17:
            case "end":
              return _context42.stop();
          }
        }, _callee42, this);
      }));
    }
  }]);
  return GoTrueClient;
}();
export { GoTrueClient as default };